import * as React from 'react';
import { Button } from 'react-bootstrap';

import './Viewer.css';

interface ViewerProps {
  url: string;
}

export const Viewer = ({ url }: ViewerProps) => (
  <div className="Viewer">
    <i className="fa fa-spinner fa-spin fa-3x"/>
    <object data={url} type="application/pdf" aria-label="Document PDF viewer">
      <div className="fallback">
        <h3>
          <span>This browser does not support viewing documents inline</span>
          <br/>
          <Button href={url} target="_blank">
            <i className="fa fa-download"/> Download
          </Button>
        </h3>
      </div>
    </object>
  </div>
);



// WEBPACK FOOTER //
// ./src/DocView/Viewer/Viewer.tsx